/* ============================================================================
   IFS CUSTOM MEGA MENU — assets/mega-menu-ifs.js
   New file: safe across Enterprise theme upgrades. See snippet UPGRADE-NOTES.
   Behavior: rail hover switches instrument context; maker hover drives the
   preview window; idle preview = newest arrival; touch = tap-to-preview,
   tap-again-to-go. Panel open/close is handled by the theme (details +
   main-menu hover logic) — this file only manages content inside the panel.
   ========================================================================== */
(function () {
  'use strict';

  var DESKTOP_MQ = '(min-width: 768px)';

  function isDesktop() {
    return window.matchMedia(DESKTOP_MQ).matches;
  }

  function initMega(mega) {
    var railLinks = mega.querySelectorAll('.js-ifs-rail');
    var contents = mega.querySelectorAll('.js-ifs-content');

    /* ---------- instrument rail ---------- */
    function activateInstrument(handle) {
      railLinks.forEach(function (l) {
        l.classList.toggle('is-active', l.dataset.instrument === handle);
      });
      contents.forEach(function (c) {
        var match = c.dataset.instrument === handle;
        c.classList.toggle('is-hidden', !match);
        if (match) resetPreview(c);
      });
    }

    railLinks.forEach(function (link) {
      link.addEventListener('mouseenter', function () {
        if (isDesktop()) activateInstrument(link.dataset.instrument);
      });
      link.addEventListener('click', function (e) {
        if (isDesktop()) {
          // Desktop tap: if this instrument isn't active yet, first tap
          // switches context instead of navigating.
          if (!link.classList.contains('is-active')) {
            e.preventDefault();
            activateInstrument(link.dataset.instrument);
          }
        } else {
          // Mobile: rail is level 1 — tap drills into the instrument.
          e.preventDefault();
          drillIn(link.dataset.instrument);
        }
      });
    });

    /* ---------- mobile drill-in ---------- */
    var grid = mega.querySelector('.ifs-mega__grid');

    function drillIn(handle) {
      if (grid) grid.classList.add('is-drilled');
      contents.forEach(function (c) {
        c.classList.toggle('is-mobile-open', c.dataset.instrument === handle);
      });
      if (grid) grid.scrollTop = 0;
      var drawer = mega.closest('.main-nav__child, .ifs-mega__panel') || grid;
      if (drawer) drawer.scrollTop = 0;
    }

    function drillOut() {
      if (grid) grid.classList.remove('is-drilled');
      contents.forEach(function (c) { c.classList.remove('is-mobile-open'); });
    }

    mega.querySelectorAll('.js-ifs-back').forEach(function (btn) {
      btn.addEventListener('click', drillOut);
    });

    /* ---------- maker preview ---------- */
    function previewEls(content) {
      return {
        img: content.querySelector('.js-ifs-preview-img'),
        title: content.querySelector('.js-ifs-preview-title'),
        blurb: content.querySelector('.js-ifs-preview-blurb'),
        cta: content.querySelector('.js-ifs-preview-cta')
      };
    }

    function resetPreview(content) {
      var p = previewEls(content);
      if (!p.title) return;
      content.querySelectorAll('.js-ifs-maker.is-active').forEach(function (m) {
        m.classList.remove('is-active');
      });
      if (p.img) {
        if (p.img.dataset.idleSrc) {
          p.img.src = p.img.dataset.idleSrc;
          p.img.style.display = '';
        } else {
          p.img.removeAttribute('src');
          p.img.style.display = 'none';
        }
      }
      p.title.textContent = p.title.dataset.idleTitle || '';
      p.blurb.textContent = p.blurb.dataset.idleBlurb || '';
      p.cta.textContent = p.cta.dataset.idleCta || '';
      if (p.cta.dataset.idleHref) p.cta.href = p.cta.dataset.idleHref;
    }

    function showMaker(content, makerLink) {
      var p = previewEls(content);
      if (!p.title) return;
      content.querySelectorAll('.js-ifs-maker.is-active').forEach(function (m) {
        m.classList.remove('is-active');
      });
      makerLink.classList.add('is-active');
      if (p.img && makerLink.dataset.img) {
        p.img.src = makerLink.dataset.img;
        p.img.style.display = '';
      }
      p.title.textContent = makerLink.dataset.name || '';
      p.blurb.textContent = makerLink.dataset.blurb || '';
      p.cta.textContent = makerLink.dataset.cta || '';
      p.cta.href = makerLink.href;
    }

    contents.forEach(function (content) {
      var makerList = content.querySelector('.ifs-makers__list');
      if (!makerList) return;

      content.querySelectorAll('.js-ifs-maker').forEach(function (makerLink) {
        makerLink.addEventListener('mouseenter', function () {
          if (isDesktop()) showMaker(content, makerLink);
        });
        makerLink.addEventListener('click', function (e) {
          // Touch: first tap previews, second tap (or the CTA) navigates.
          // Only intercept when hover cannot have happened (coarse pointer).
          var coarse = window.matchMedia('(hover: none)').matches;
          if (isDesktop() && coarse && !makerLink.classList.contains('is-active')) {
            e.preventDefault();
            showMaker(content, makerLink);
          }
        });
      });

      // Reset to idle only when leaving the WHOLE makers row (names +
      // preview), so moving from a name to its Shop button keeps the state.
      var row = content.querySelector('.ifs-makers__row') || makerList;
      row.addEventListener('mouseleave', function () {
        if (isDesktop() && !window.matchMedia('(hover: none)').matches) {
          resetPreview(content);
        }
      });

      resetPreview(content); // seed idle state
    });

    /* ---------- mobile carousel: first-open settle hint ---------- */
    // Nudge the carousel ~14px and settle back the first time it becomes
    // visible, signalling swipeability. Runs once per carousel per page.
    var carousels = mega.querySelectorAll('.ifs-mcarousel');
    if ('IntersectionObserver' in window && carousels.length) {
      var seen = new WeakSet();
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || seen.has(entry.target)) return;
          seen.add(entry.target);
          var el = entry.target;
          if (el.scrollWidth <= el.clientWidth) return; // nothing to swipe
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          el.scrollTo({ left: 14, behavior: 'smooth' });
          setTimeout(function () { el.scrollTo({ left: 0, behavior: 'smooth' }); }, 420);
        });
      }, { threshold: 0.6 });
      carousels.forEach(function (c) { io.observe(c); });
    }
  }

  function init() {
    document.querySelectorAll('.js-ifs-mega').forEach(initMega);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
